module.exports = __webpack_public_path__ + "img/newmutants.ac3f573c.svg";